import {
  Directive,
  HostListener,
  Input,
  ElementRef,
  forwardRef
} from '@angular/core';
import {
  NG_VALUE_ACCESSOR,
  ControlValueAccessor,
  NG_VALIDATORS,
  Validator,
  AbstractControl,
  ValidationErrors
} from '@angular/forms';

@Directive({
  selector: '[appNumberFormat]',
  standalone: true ,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NumberFormatDirective),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => NumberFormatDirective),
      multi: true
    }
  ]
})
export class NumberFormatDirective implements ControlValueAccessor, Validator {
  @Input('appNumberFormat') decimals = 2;

  private onChange = (_: any) => {};
  private onTouched = () => {};
  private value: string = '';

  constructor(private el: ElementRef<HTMLInputElement>) {}

  @HostListener('input', ['$event.target.value'])
  onInput(value: string) {
    const clean = value.replace(/,/g, '');
    this.value = value;

    const numeric = parseFloat(clean);
    if (!isNaN(numeric)) {
      this.onChange(numeric);
    } else {
      this.onChange(null);
    }
  }

  @HostListener('blur')
  onBlur() {
    this.onTouched();

    const clean = this.el.nativeElement.value.replace(/,/g, '');
    const numeric = parseFloat(clean);
    if (!isNaN(numeric)) {
      const formatted = numeric.toLocaleString('en-US', {
        minimumFractionDigits: this.decimals,
        maximumFractionDigits: this.decimals
      });
      this.el.nativeElement.value = formatted;
    }
  }

  @HostListener('focus')
  onFocus() {
    this.el.nativeElement.value = this.el.nativeElement.value.replace(/,/g, '');
  }

  writeValue(value: any): void {
    if (value == null || isNaN(value)) {
      this.el.nativeElement.value = '';
    } else {
      this.el.nativeElement.value = value.toLocaleString('en-US', {
        minimumFractionDigits: this.decimals,
        maximumFractionDigits: this.decimals
      });
    }
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.el.nativeElement.disabled = isDisabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    const regex = new RegExp(
      `^\\d{1,3}(,\\d{3})*(\\.\\d{1,${this.decimals}})?$|^\\d+(\\.\\d{1,${this.decimals}})?$`
    );
    const value = this.el.nativeElement.value;

    if (!value || regex.test(value)) {
      return null;
    }

    return { invalidNumberFormat: true };
  }
}
